"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceOrRange = void 0;
var formatted_price_1 = __importDefault(require("../../../utils/product/formatted-price"));
/**
 * Converts a price value or range to a string representation.
 * @param price - The price value or range.
 * @returns The string representation of the price.
 */
var getPriceOrRange = function (price) {
    if (price === null || price === undefined || price === '') {
        return null;
    }
    if (typeof price === 'object') {
        return "".concat((0, formatted_price_1.default)(price === null || price === void 0 ? void 0 : price.from), " \u2013 ").concat((0, formatted_price_1.default)(price === null || price === void 0 ? void 0 : price.to));
    }
    else {
        return (0, formatted_price_1.default)(price);
    }
};
exports.getPriceOrRange = getPriceOrRange;
//# sourceMappingURL=getPriceOrRange.js.map